import React from 'react'
import PropTypes from 'prop-types'
import RenderLegend from 'analytics/components/Chart/Legend/Legend.component'

import RowTabItems from 'shared/components/common/RowTabItems/RowTabItems.component'
import iconArrowLeft from 'shared/assets/icons/keyboard-arrow-left-24px.svg'
import iconArrowRight from 'shared/assets/icons/keyboard-arrow-right-24px.svg'
import iconBarChart from 'shared/assets/icons/bar-chart-24px.svg'
import iconLineChart from 'shared/assets/icons/line-chart-24px.svg'
import iconTableChart from 'shared/assets/icons/table-chart-24px.svg'

const setDefaultBarItem = defaultChartType => {
  switch (defaultChartType) {
    case 'bar': {
      return { icon: iconBarChart, action: 'bar' }
    }

    case 'sentiments':
    case 'line': {
      return { icon: iconLineChart, action: 'line' }
    }
  }
}

const ChartLegend = props => (
  <>
    {props.renderSwitchDate && <RowTabItems
      items={[
        { icon: iconArrowLeft, action: 'back', iconInlineStyles: { height: '24px' } },
        { icon: iconArrowRight, action: 'forward', iconInlineStyles: { height: '24px' } }
      ]}
      onClick={props.onMoveCustomDateRange}
    />}

    {props.renderLegend && <RenderLegend {...props} />}

    {props.renderGranularity && <RowTabItems
      activeAction={props.granularity}
      items={[
        { title: 'Day', action: 'day' },
        { title: 'Week', action: 'week' },
        { title: 'Month', action: 'month' }
      ]}
      onClick={props.onChangeGranularity}
    />}

    {props.renderSwitchCharts && <RowTabItems
      activeAction={props.chartType}
      items={[
        setDefaultBarItem(props.defaultChartType),
        { icon: iconTableChart, action: 'table', iconInlineStyles: { height: '16px' } }
      ]}
      onClick={props.onChangeChartType}
    />}
  </>
)

ChartLegend.propTypes = {
  defaultChartType: PropTypes.string,
  chartType: PropTypes.string.isRequired,
  dateRange: PropTypes.string.isRequired,
  granularity: PropTypes.string.isRequired,
  onChangeGranularity: PropTypes.func.isRequired,
  onChangeChartType: PropTypes.func.isRequired,
  onMoveCustomDateRange: PropTypes.func.isRequired,
  renderGranularity: PropTypes.bool,
  renderLegend: PropTypes.bool,
  renderSwitchCharts: PropTypes.bool,
  renderSwitchDate: PropTypes.bool
}

ChartLegend.defaultProps = {
  renderGranularity: true,
  renderLegend: true,
  renderSwitchCharts: true,
  renderSwitchDate: true
}

export default ChartLegend
